export const ANONYMOUS_USER_ICON =
  'https://i.vimeocdn.com/custom_asset/92992640f627fdad710e4c3cb728b1b2';
export const ANONYMOUS_PENDING_ICON = 'https://i.vimeocdn.com/portrait/defaults-gray_75x75.png';
